import type { ReactElement } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Permanent redirect for the retired `/plugin/:slug` URL to the canonical
 * `/catalog/:slug`. Plugin detail moved under the catalog hierarchy so the
 * breadcrumb ancestor ("Catalog") is a real matched route rather than a
 * fabricated crumb. This keeps old bookmarks, PR demo GIFs, and external
 * deep links working — including any query string they carry (e.g.
 * `?tab=readme`), which is why `location.search` is forwarded rather than
 * dropped.
 */
export function LegacyPluginRedirect(): ReactElement {
  const { slug } = useParams<{ slug: string }>();
  const { search } = useLocation();
  return <Navigate to={`/catalog/${slug ?? ''}${search}`} replace />;
}
